var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/_uid.js
// module id = 1461
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 17 18 19 20 21